import { CALL_API } from '../middleware/ApiMiddleware';

export const MUNICIPAL_CODES_FETCH_REQUEST = 'MUNICIPAL_CODES_FETCH_REQUEST';
export const MUNICIPAL_CODES_FETCH_SUCCESS = 'MUNICIPAL_CODES_FETCH_SUCCESS';
export const MUNICIPAL_CODES_FETCH_FAILURE = 'MUNICIPAL_CODES_FETCH_FAILURE';

export const MUNICIPAL_CODE_FETCH_REQUEST = 'MUNICIPAL_CODE_FETCH_REQUEST';
export const MUNICIPAL_CODE_FETCH_SUCCESS = 'MUNICIPAL_CODE_FETCH_SUCCESS';
export const MUNICIPAL_CODE_FETCH_FAILURE = 'MUNICIPAL_CODE_FETCH_FAILURE';

export const MUNICIPAL_CODE_CREATE_REQUEST = 'MUNICIPAL_CODE_CREATE_REQUEST';
export const MUNICIPAL_CODE_CREATE_SUCCESS = 'MUNICIPAL_CODE_CREATE_SUCCESS';
export const MUNICIPAL_CODE_CREATE_FAILURE = 'MUNICIPAL_CODE_CREATE_FAILURE';

export const MUNICIPAL_CODE_EDIT_REQUEST = 'MUNICIPAL_CODE_EDIT_REQUEST';
export const MUNICIPAL_CODE_EDIT_SUCCESS = 'MUNICIPAL_CODE_EDIT_SUCCESS';
export const MUNICIPAL_CODE_EDIT_FAILURE = 'MUNICIPAL_CODE_EDIT_FAILURE';

const baseURL = 'xerce/config/municipal-codes';

export const fetchMunicipalCodes = (params?: IMunicipalCodeListingParams, hideLoading?: boolean) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [MUNICIPAL_CODES_FETCH_REQUEST, MUNICIPAL_CODES_FETCH_SUCCESS, MUNICIPAL_CODES_FETCH_FAILURE],
    hideLoadingWidget: hideLoading,
  },
});

export const fetchMunicipalCode = (municipalCodeId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${municipalCodeId}`,
    method: 'get',
    authenticated: true,
    types: [MUNICIPAL_CODE_FETCH_REQUEST, MUNICIPAL_CODE_FETCH_SUCCESS, MUNICIPAL_CODE_FETCH_FAILURE],
  },
});

export const createMunicipalCode = (muncipalCode: IMunicipalCodeRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    authenticated: true,
    body: muncipalCode,
    types: [MUNICIPAL_CODE_CREATE_REQUEST, MUNICIPAL_CODE_CREATE_SUCCESS, MUNICIPAL_CODE_CREATE_FAILURE],
  },
});

export const editMunicipalCode = (municipalCodeId: number, municipalCode: IMunicipalCodeRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${municipalCodeId}`,
    method: 'put',
    authenticated: true,
    body: municipalCode,
    types: [MUNICIPAL_CODE_EDIT_REQUEST, MUNICIPAL_CODE_EDIT_SUCCESS, MUNICIPAL_CODE_EDIT_FAILURE],
  },
});
